export async function consoleLogo(logoBase64: string) {
	const size = 42;
	const image = new Image();
	image.src = logoBase64;
	image.onload = function () {
		const styles = [
			`font-size: 20px;
						padding: ${(image.height / 100) * size}px ${(image.width / 100) * size}px;
						background: url(${logoBase64}) no-repeat;
						background-size: contain;
						text-align: center;`,
			'font-size: 16px; color: red; font-weight: bold; text-align: center;',
		];
		console.log(
			'%c \x1b[0m' +
				'\n %cPara sua segurança, não copie ou cole qualquer comando nesta área. Em caso de dúvida, procure a área técnica.',
			...styles,
		);
	};
}
